/**
 * Custom hook for managing PDF generation state
 */

import { useState, useEffect } from 'react'
import { isNil } from '@/utils/lodash'

export const usePDFState = (props) => {
  const { me } = props.session
  const isLoggedIn = !isNil(me) ? true : false

  const [state, setState] = useState({
    display: props.display ? props.display : false,
    showEmail: false,
    showLink: false,
    emails: [],
    docDefinition: '',
    dataURL: '',
    blob: '',
    queried: false,
    qassumption: false,
    called: false,
    property: {},
    anchorEl: null,
    open: false,
    backdrop: false,
    type: props.type || 'buyHold',
    flyers: [],
    emailImagePage: false,
    southernImpressions: isLoggedIn
      ? me.activeOrg.southernImpressions ||
        (me.activeOrg.parentCorp &&
          me.activeOrg.parentCorp.southernImpressions)
      : false,
  })

  // Update type when props change
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      type: props.type || 'buyHold',
    }))
  }, [props.type])

  const updateState = (updates) => {
    setState((prevState) => ({ ...prevState, ...updates  }))
  }

  const toggleEmailModal = () => {
    props.handleShareClose?.()
    setState((prevState) => ({
      ...prevState,
      showEmail: !prevState.showEmail,
      emailImagePage: false,
    }))
  }

  const handleChange = (event) => {
    const { name = '', value = '' } = event.target
    setState((prevState) => ({ ...prevState, [name]: value  }))
  }

  const setEmailImagePage = (value) => {
    setState((prevState) => ({
      ...prevState,
      emailImagePage: value,
      dataURL: null,
    }))
  }

  const setFlyers = (flyers) => {
    setState((prevState) => ({
      ...prevState,
      flyers,
    }))
  }

  const setBackdrop = (backdrop) => {
    setState((prevState) => ({
      ...prevState,
      backdrop,
    }))
  }

  const clearEmails = () => {
    setState((prevState) => ({
      ...prevState,
      emails: [],
    }))
  }

  const setDataURL = (dataURL) => {
    setState((prevState) => ({
      ...prevState,
      dataURL,
    }))
  }

  const setBlob = (blob) => {
    setState((prevState) => ({
      ...prevState,
      blob,
    }))
  }

  return {
    state,
    updateState,
    toggleEmailModal,
    handleChange,
    setEmailImagePage,
    setFlyers,
    setBackdrop,
    clearEmails,
    setDataURL,
    setBlob,
  }
}
